export function RoleChips({ roles, value, onChange, testid = "role-chips" }) {
  const toggle = (r) => onChange(value.includes(r) ? value.filter((x) => x !== r) : [...value, r]);
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {roles.length === 0 && <p className="text-xs text-muted-foreground">No roles yet. Add them on the Staff page.</p>}
      {roles.map((r) => {
        const on = value.includes(r);
        return (
          <button key={r} type="button" onClick={() => toggle(r)} data-testid={`${testid}-${r.toLowerCase().replace(/\s+/g, "-")}`}
            className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors duration-200 ${on
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-transparent text-muted-foreground border-border hover:text-foreground"}`}>
            {r}
          </button>
        );
      })}
    </div>
  );
}
